import { render, staticRenderFns } from "./FleshLeft.vue?vue&type=template&id=70ab263c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ab263c')) {
      api.createRecord('70ab263c', component.options)
    } else {
      api.reload('70ab263c', component.options)
    }
    module.hot.accept("./FleshLeft.vue?vue&type=template&id=70ab263c&", function () {
      api.rerender('70ab263c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/FleshLeft.vue"
export default component.exports